<footer>
  <a class="footer-logo" routerLink="/" aria-label="ATSIestudio, inicio">
    <img src="/images/atsi-estudio-logo.svg" width="1200" height="360" alt="" />
  </a>
  <nav aria-label="Información legal">
    <ul>
      <li><a routerLink="/aviso-legal">Aviso legal</a></li>
      <li><a routerLink="/privacidad">Privacidad</a></li>
      <li><a routerLink="/cookies">Política de cookies</a></li>
      <li><button type="button" (click)="consent.openSettings()">Configurar privacidad</button></li>
    </ul>
  </nav>
</footer>
